/**
 * @description: 检查用户是否具有某一个权限（只校验菜单和组件的code，不包含操作code）
 * @param {string} code 校验权限的code
 * 使用方式：
 * useCheckPermission(['ALARM_PAGE'])
 * useCheckPermission(['ALARM_PAGE.U'])
 */
import { useUserStore } from '@/store/modules/user';
import { intersection } from '@/utils/index';

export const useCheckPermission = (authCodes: string[]): boolean => {
  const userStore = useUserStore();
  const authKeys: string[] = userStore.authKeys;

  return intersection(authKeys, authCodes).length > 0;
};
